const banners = document.querySelectorAll('.banner');

banners.forEach(banner => {
  const button = banner.querySelector('.banner__button .button');
  const inputs = banner.querySelectorAll('.banner__radio input');

  inputs.forEach((input, i) => {
    if (i === 0) {
      button.href = input.value;
    }

    input.addEventListener('change', () => {
      button.href = input.value;
    });
  });
})
